__turbopack_context__.v({
  "className": "-Qgr4W_className",
  "variable": "-Qgr4W_variable",
});
